import { cn } from '@sharpr/ui';
import { TrendingUp } from 'lucide-react';
import { NBA_RESULTS } from './nbaResults.generated';

const EDGE10 = NBA_RESULTS.tiers.edge10;

/** One-line results proof — pricing hero + signup panel. Links to the full section when `href` is set. */
export function ResultsProofPill({ href, className }: { href?: string; className?: string }) {
  const body = (
    <>
      <TrendingUp className="h-3.5 w-3.5 shrink-0 text-emerald-600 dark:text-emerald-400" />
      <span>
        <span className="font-semibold text-emerald-600 dark:text-emerald-400">
          +{(EDGE10.roi * 100).toFixed(1)}% ROI
        </span>{' '}
        on our 10%+ edges · {NBA_RESULTS.label}
      </span>
    </>
  );
  const cls = cn(
    'inline-flex items-center gap-1.5 rounded-full border border-[var(--glass-border)] bg-fg/[0.03] px-3 py-1 text-xs font-medium text-fg/75',
    href && 'hover:bg-fg/[0.06] hover:text-fg transition-colors',
    className,
  );
  return href ? (
    <a href={href} className={cls}>
      {body}
    </a>
  ) : (
    <p className={cls}>{body}</p>
  );
}
